'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';

export default class HasSubrecipes extends Component {
    static propTypes = {
        params: PropTypes.object,
        onChangeParams: PropTypes.func,
    };

    toggleHasSubrecipes = () => {
        const { params, onChangeParams } = this.props;

        if (params.filters.has_subrecipes) {
            delete params.filters.has_subrecipes;
        } else {
            params.filters.has_subrecipes = true;
        }

        onChangeParams(params);
    }

    render() {
        const { params } = this.props;

        return (
            <span className="global-search-hideable-filter my-library-toggle">
                <button className="el-checkbox" data-active={params.filters.has_subrecipes === true}
                       onClick={this.toggleHasSubrecipes}>
                    Has Foundational Recipes
                </button>
            </span>
        );
    }
}
